<app-layout *ngIf="breakpointObserver.isMatched('(max-width: 599px)')">
  <!-- Main Content -->
  <ng-template #topBar>
    <app-topbar [avatar]="userAvatar"></app-topbar>
  </ng-template>
  <ng-template #sideContent let-isMobile="isMobile" let-position="position">
    <app-sidenav
      [items]="navigationBarItems"
      [logo]="customerLogo"
      [avatar]="userAvatar"
      [isMobile]="isMobile"
      [position]="position"
    ></app-sidenav>
  </ng-template>
  <ng-template #mainContent>
    <router-outlet></router-outlet>
  </ng-template>
</app-layout>

<app-topbar
  [avatar]="userAvatar"
  *ngIf="!breakpointObserver.isMatched('(max-width: 599px)')"
></app-topbar>
<mat-sidenav-container
  *ngIf="!breakpointObserver.isMatched('(max-width: 599px)')"
  hasBackdrop="false"
>
  <mat-sidenav
    [mode]="sidenavMode"
    opened
    [ngClass]="sidebarToggle ? 'sidebar-opened' : 'sidebar-closed'"
    autosize
  >
    <div fxLayout="column">
      <app-sidebar-nav
        [items]="navigationBarItems"
        [logo]="customerLogo"
        [avatar]="userAvatar"
        fxLayout="stretch"
      ></app-sidebar-nav>
    </div>
  </mat-sidenav>

  <mat-sidenav-content
    style="background-color: #fafafa"
    [@onSideNavChange]="sidebarState"
  >
    <div
      #container
      [ngClass]="{
        'main-container-new': isOpen && sidenavMode === 'side',
        'main-container': !isOpen && sidenavMode === 'side',
        'main-container-tablet': !isOpen && sidenavMode !== 'side'
      }"
      class="main-container-gt-xs custom-height scroll-panel"
      [class.scroll]="scrollEnabled"
    >
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
